import { FormHelperText, InputAdornment, TextField } from '@mui/material';

import { CollapseFilter } from '../collapse-filter';

type TextFieldFilterProps = {
  title: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  endAdornment?: string;
  numeric?: boolean;
  maxLength?: number;
  disabled?: boolean;
  helperText?: string;
};

export const TextFieldFilter = (props: TextFieldFilterProps) => {
  const {
    title,
    value,
    onChange,
    placeholder,
    endAdornment,
    numeric,
    maxLength,
    disabled,
    helperText,
  } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.value;
    onChange(numeric ? raw.replace(/\D/g, '') : raw);
  };

  const slotProps = {
    input: endAdornment
      ? { endAdornment: <InputAdornment position="end">{endAdornment}</InputAdornment> }
      : undefined,
    htmlInput:
      numeric || maxLength
        ? { inputMode: numeric ? ('numeric' as const) : undefined, maxLength }
        : undefined,
  };

  return (
    <CollapseFilter title={title}>
      <TextField
        placeholder={placeholder}
        size="small"
        fullWidth
        variant="outlined"
        value={value}
        onChange={handleChange}
        slotProps={slotProps}
        disabled={disabled}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </CollapseFilter>
  );
};
